
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4398_4108)"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#5D5CFD"}}),_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5","transform":"matrix(-1 0 0 1 39 36)","fill":"#16171F"}}),_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5","transform":"matrix(-1 0 0 1 40 0)","fill":"#16171F"}}),_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5","transform":"matrix(-1 0 0 1 3 37)","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.6247 12.9497C30.2047 13.5018 30.2274 14.4196 29.6753 14.9997L18.2538 26.9997C17.9803 27.2871 17.6009 27.4498 17.2041 27.45C16.8074 27.4502 16.4279 27.2877 16.1541 27.0006L10.3255 20.8874C9.77294 20.3078 9.79482 19.39 10.3744 18.8374C10.954 18.2848 11.8718 18.3066 12.4244 18.8862L17.2026 23.8978L27.5747 13.0003C28.1268 12.4202 29.0446 12.3976 29.6247 12.9497Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4398_4108"}},[_c('rect',{attrs:{"width":"40","height":"40","fill":"white"}})])])])
          )
        }
      }
    